module.exports = __webpack_public_path__ + "static/media/menu-achievements.a5ec465b.png";